
import { FC } from "react";
import { ICard } from "../../../interfaces";

import frontSideQuestion from "../../../assets/cards/question.svg";

interface IChallengeCardReadOnly {
    cardData: ICard;
}


const ChallengeCardReadOnly: FC<IChallengeCardReadOnly> = ({ cardData }) => {

    return (
        <div className="card_read_only" >
            <img className="front_side_card_read_only_image" src={frontSideQuestion} alt="front side action" />
            <div className="front_side_card_read_only_content">
                <p className="front_side_card_read_only_title">{cardData.title}</p>
                <p className="front_side_card_read_only_body">{cardData.description}</p>
            </div>
        </div>
    );
}

export default ChallengeCardReadOnly;